var ENDPOINTS = {
    favorites: "/umbraco/api/contentList/GetListOfNodes",
    pageList: "/umbraco/api/list/getlistByTags",
    eventList: "/umbraco/api/eventList/getEvents",
    pureList: "/umbraco/api/PublicationList/GetPublicationList",
    eResourceList: "/umbraco/api/List/getEResourceList",
    findEducation: "/umbraco/api/findeducation/getEducations",
    findEducationFilters: "/umbraco/api/findeducation/getFilters",
    search: "/umbraco/api/SiteSearch/search",
    employeeSearch: "/umbraco/api/EmployeeList/GetEmployeeList",
    employeeSearchFilters: "/umbraco/api/EmployeeList/GetEmployeeListFilterOptions",
    EVUChildrenList: "/umbraco/Api/EVUChildrenList/GetEVUChildren",
    EVUChildrenListFilters: "/umbraco/Api/EVUChildrenList/GetFilters",
    EVU: "/umbraco/Api/EVU/GetEVUEducations",
    EVUFilters: "/umbraco/Api/EVU/GetFilters",
    subscribeToModule: "/umbraco/Api/EmailSubscription/SubscribeToModule",
    educationOverviewList: "/umbraco/Api/EducationOverviewList/GetOverviewList",
    educationOverviewListFilters: "/umbraco/Api/EducationOverviewList/GetFilters",
};
export { ENDPOINTS };
